import { CSSProperties } from 'react';

import { MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_SECOND } from '@/consts';

const OAUTH_REDIRECT_VALIDATION_TIME_MIN = 15;

export const OAUTH_REDIRECT_VALIDATION_TIME = MILLISECONDS_IN_MINUTE * OAUTH_REDIRECT_VALIDATION_TIME_MIN;

export const SIGN_OUT_REDIRECT_VALIDATION_TIME = MILLISECONDS_IN_MINUTE;

const JUST_LOGGED_IN_TIMEOUT_SECONDS = 10;

export const JUST_LOGGED_IN_TIMESTAMP_KEY = 'justLoggedInToRecipientPage';

export const JUST_LOGGED_IN_TIMEOUT_MS = JUST_LOGGED_IN_TIMEOUT_SECONDS * MILLISECONDS_IN_SECOND;

export const MAIN_SPINNER_STYLE: CSSProperties = {
    position: 'fixed',
    top: '20vh',
};

export const errorsNameSpace = 'recipientPage.errors';
